<div class="shopping-container px-base py-tiny d-block d-lg-none">
    <div class="shopping-bar d-flex jc-space-between ai-center px-tiny">
        <span class="shopping-bar__value">{{count + planCounter}}</span>
        <button class="shopping-bar__button py-xsmall text-small ai-center d-inline-flex" type="button" (click)="openShoppingDialog()"><span class="material-icons pr-tiny text-small">local_grocery_store</span>ver carrito</button>
        <span class="shopping-bar__price">${{total.toLocaleString()}}</span>
    </div>
</div>